//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useSearch1, useSave1, useDelete1 } from './ACS_BASIC_01_QUERY';
import ACS_BASIC_01 from './ACS_BASIC_01';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useFileUpload from '../../../../hooks/useFileUpload';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { ACS_BASIC_01_Schema, mapGetAccBasic01R1RowToGrid } from './ACS_BASIC_01_Schema';
import { showLoading, closeLoading } from '../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
//#endregion

//#region 상수
const SCREEN_MENU_ID = 'AccidentStatus';
//#endregion

function ACS_BASIC_01F(props) {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const { previewUrl, previewFileName } = useSelector((state) => state.fileField);
  const gridRef1 = useRef();
  const rowClickData = useRef(null);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);

  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRows, setDeletedRowData1] = useState([]);
  const [modalToggle1, setModalToggle1] = useState(false);
  const [gongjongModalToggle, setGongjongModalToggle] = useState(false);
  const [fileModalToggle, setFileModalToggle] = useState(false);
  const [currentFileFieldType, setCurrentFileFieldType] = useState('investigationStatFile');
  const gongjongRowDataRef = useRef(null);

  const { validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  const { SaveLogicPreview: SaveLogicPreviewSurvey, SaveLogicFile: SaveLogicFileSurvey, DeleteLogicFile: DeleteLogicFileSurvey } =
    useFileUpload({
      oldFilePathField: 'investigationStatFilePath',
      newFileNameField: 'investigationStatSaveName',
      getTargetPath: () => `AccidentStatus/${searchInfo.custCd}/ACS_BASIC_01/InvestigationStat`,
    });

  const { SaveLogicPreview: SaveLogicPreviewReport, SaveLogicFile: SaveLogicFileReport, DeleteLogicFile: DeleteLogicFileReport } =
    useFileUpload({
      oldFilePathField: 'reportFilePath',
      newFileNameField: 'reportSaveName',
      getTargetPath: () => `AccidentStatus/${searchInfo.custCd}/ACS_BASIC_01/Report`,
    });

  const SaveLogicPreview = currentFileFieldType === 'investigationStatFile' ? SaveLogicPreviewSurvey : SaveLogicPreviewReport;

  const getFileFields = (type) => {
    const isInvestigationStat = type === 'investigationStatFile';
    return {
      fileNameField: isInvestigationStat ? 'investigationStatFileName' : 'reportFileName',
      saveNameField: isInvestigationStat ? 'investigationStatSaveName' : 'reportSaveName',
      filePathField: isInvestigationStat ? 'investigationStatFilePath' : 'reportFilePath',
      previewFilePathField: isInvestigationStat ? 'investigationStatPreviewFilePath' : 'reportPreviewFilePath',
    };
  };

  //#region useEffect
  useEffect(() => {
    if (props.filterClick1) {
      gridRef1?.current?.api?.setQuickFilter?.(searchInfo?.searchText || '');
      props.setFilterClick1?.(false);
    }
    if (props.saveClick1) {
      // 편집중인 셀의 값을 먼저 확정(commit) 후 저장 로직 실행
      gridRef1?.current?.api?.stopEditing?.();
      Save1();
      props.setSaveClick1?.(false);
    }
    if (props.printClick1) {
      if (validateSelection()) PrintLogic1();
      props.setPrintClick1?.(false);
    }
    if (props.searchClick1) {
      SearchLogic1();
      props.setSearchClick1?.(false);
    }
  }, [props.filterClick1, props.saveClick1, props.printClick1, props.searchClick1]);
  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      const mapped = (rows || []).map(mapGetAccBasic01R1RowToGrid).filter(Boolean);
      setRowData1(mapped);
    },
  });

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRows,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 부분 갱신 처리
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.accidentSeq ?? row.no ?? row.id,
    getKeyFromResult: (result) =>
      result?.AccidentSeq ?? result?.accidentSeq ?? result?.no ?? result?.id,
  });

  // 저장 (필수체크: useSave 내부 schema 기반 validateRequiredWithMessage 사용)
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '발생일시, 부서, 성명, 공정, 사고경위',
    schema: { fields: ACS_BASIC_01_Schema.fields },
    // 그리드 실제 행 데이터 기준으로 변경 행 인식
    // - 저장 직전에 gridRef1.api.forEachNode로 모든 행을 돌면서
    // - editYn === 'Y' && deleteYn !== 'Y' 인 행을 모두 수집
    // - onCellValueChanged / FileUploadDialog 등이 e.node.setData({ ..., editYn: 'Y' }) 한 최신 값 그대로 사용
    getChangedRows: () => {
      const result = [];
      gridRef1?.current?.api?.forEachNode?.((node) => {
        const d = node?.data;
        if (!d) return;
        if (d.deleteYn === 'Y') return;
        if (d.editYn === 'Y') {
          result.push({ ...d });
        }
      });
      return result;
    },
    getDeletedRows: () => deletedRows,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => Save1Async(rows),
    fileDelete: async (deletedRowsToDelete) => {
      for (const item of deletedRowsToDelete) {
        if (item.investigationStatFilePath) {
          await DeleteLogicFileSurvey(item.investigationStatFilePath);
        }
        if (item.reportFilePath) {
          await DeleteLogicFileReport(item.reportFilePath);
        }
      }
    },
    fileSave: async (changedRows) => {
      const custCd = searchInfo.custCd || '';
      const surveyTargetDir = `AccidentStatus/${custCd}/ACS_BASIC_01/InvestigationStat`;
      const reportTargetDir = `AccidentStatus/${custCd}/ACS_BASIC_01/Report`;
      const surveyRows = changedRows.filter(
        (r) => r.investigationStatPreviewFilePath && r.investigationStatSaveName
      );
      if (surveyRows.length) {
        const surveyItems = surveyRows.map((r) => ({
          ...r,
          previewFilePath: r.investigationStatPreviewFilePath,
        }));
        const surveyResult = await SaveLogicFileSurvey(surveyItems, custCd);
        if (surveyResult) {
          surveyRows.forEach((r) => {
            r.investigationStatFilePath = `${surveyTargetDir}/${r.investigationStatSaveName}`;
          });
        }
      }
      const reportRows = changedRows.filter(
        (r) => r.reportPreviewFilePath && r.reportSaveName
      );
      if (reportRows.length) {
        const reportItems = reportRows.map((r) => ({
          ...r,
          previewFilePath: r.reportPreviewFilePath,
        }));
        const reportResult = await SaveLogicFileReport(reportItems, custCd);
        if (reportResult) {
          reportRows.forEach((r) => {
            r.reportFilePath = `${reportTargetDir}/${r.reportSaveName}`;
          });
        }
      }
    },
    onSuccessRefresh: () => SearchLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll?.();
  };

  const SearchLogic1 = async () => {
    ResetLogic();
    if (!validateSelection()) return;
    await Search1();
  };
  //#endregion

  //#region 나머지 함수
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const updateGridRow = (rowNode, selected) => {
    // 부서4 → 부서3 → 부서2 → 부서1 순으로 값이 있는 가장 하위 부서를 depNm에 반영
    const depLevels = [selected.depNm4, selected.depNm3, selected.depNm2, selected.depNm1];
    const depNm = depLevels.find((v) => v != null && String(v).trim() !== '') ?? '';
    const updatedData = {
      ...rowNode.data,
      victimId: selected.id ?? '',
      victimName: selected.name ?? '',
      depNm,
      rank: selected.rank ?? '',
      tel: selected.tel ?? '',
      joinDate: selected.joinDate ?? rowNode.data.joinDate,
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    const key = updatedData.accidentSeq ?? updatedData.no ?? updatedData.id;
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => (r.accidentSeq ?? r.no ?? r.id) !== key);
      return [...filtered, updatedData];
    });
    setRowData1((prev) => {
      const list = prev || [];
      const existing = list.find((r) => (r.accidentSeq ?? r.no ?? r.id) === key);
      if (!existing) return list;
      return list.map((r) => ((r.accidentSeq ?? r.no ?? r.id) !== key ? r : { ...r, ...updatedData }));
    });
    const api = gridRef1?.current?.api;
    if (api) {
      api.setFocusedCell(rowNode.rowIndex, 'victimName');
    }
  };

  const HandleManageSelection = (selected) => {
    if (!selected) return;
    const api = gridRef1?.current?.api;
    if (!api) return;
    let rowIndex = rowClickData.current?.rowIndex;
    let rowNode = rowIndex !== undefined ? api.getDisplayedRowAtIndex(rowIndex) : null;
    if (!rowNode) {
      const allNodes = [];
      api.forEachNode((node) => allNodes.push(node));
      const newRows = allNodes.filter((n) => n.data?.newYn === 'Y');
      rowNode = newRows[newRows.length - 1];
    }
    if (rowNode) {
      updateGridRow(rowNode, selected);
    }
    rowClickData.current = null;
    setModalToggle1(false);
  };

  const PopupClickEvent1 = (e) => {
    rowClickData.current = { rowIndex: e.rowIndex, data: e.data };
    setModalToggle1(true);
  };

  const PopupGongjongClickEvent = (params) => {
    gongjongRowDataRef.current = { rowIndex: params.rowIndex, data: params.data };
    setGongjongModalToggle(true);
  };

  const HandleGongjongSelection = ({ gongjongCd, gongjongNm }) => {
    const api = gridRef1?.current?.api;
    if (!api) return;
    const { rowIndex } = gongjongRowDataRef.current ?? {};
    const rowNode = rowIndex !== undefined ? api.getDisplayedRowAtIndex(rowIndex) : null;
    if (!rowNode) return;
    const updatedData = {
      ...rowNode.data,
      gongjongCd: gongjongCd ?? '',
      gongjongNm: gongjongNm ?? '',
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    const key = updatedData.accidentSeq ?? updatedData.no ?? updatedData.id;
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => (r.accidentSeq ?? r.no ?? r.id) !== key);
      return [...filtered, updatedData];
    });
    setRowData1((prev) => {
      const list = prev || [];
      const existing = list.find((r) => (r.accidentSeq ?? r.no ?? r.id) === key);
      if (!existing) return list;
      return list.map((r) => ((r.accidentSeq ?? r.no ?? r.id) !== key ? r : { ...r, ...updatedData }));
    });
    gongjongRowDataRef.current = null;
    setGongjongModalToggle(false);
  };

  const PopupFileClickEvent = async (rowData, fieldType) => {
    setCurrentFileFieldType(fieldType);
    const { previewFilePathField, fileNameField, filePathField } = getFileFields(fieldType);
    const newPreviewPath = rowData[previewFilePathField] || '';
    const existingFilePath = rowData[filePathField] || '';
    const fileName = rowData[fileNameField] || '파일 선택';
    let previewUrl = '';
    if (newPreviewPath) {
      const fixedPath = Commons.EncodeUrl(newPreviewPath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    } else if (existingFilePath) {
      const fixedPath = Commons.EncodeUrl(existingFilePath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    }
    dispatch(setFileFields({
      previewFilePathField,
      previewFileName: fileName,
      previewUrl,
    }));
    setTimeout(() => setFileModalToggle(true), 100);
  };

  const DownloadLogic1 = async () => {
    try {
      let filePath = '';
      let fileName = previewFileName || 'downloaded_file';
      if (previewUrl) {
        if (previewUrl.startsWith('data:')) {
          const a = document.createElement('a');
          a.href = previewUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          dispatch(showSnackbar({ message: `"${fileName}" 다운로드 완료`, type: 'success' }));
          return;
        }
        filePath = previewUrl.includes(Global.file.useUrl + 'files/')
          ? decodeURIComponent(previewUrl.replace(Global.file.useUrl + 'files/', ''))
          : previewUrl;
      } else {
        const rowData = selectedRowData1?.[0];
        if (!rowData) {
          dispatch(showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' }));
          return;
        }
        const { filePathField, fileNameField } = getFileFields(currentFileFieldType);
        filePath = rowData[filePathField] || '';
        fileName = rowData[fileNameField] || fileName;
        if (!filePath) {
          dispatch(showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' }));
          return;
        }
      }
      const finalFileName = fileName === 'downloaded_file' ? decodeURIComponent(filePath.split('/').pop() || fileName) : fileName;
      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        { FileName: finalFileName, Url: Commons.EncodeUrl(filePath) }
      );
      if (!result?.data || !result?.headers?.['content-type']) {
        dispatch(showSnackbar({ message: `"${finalFileName}" 다운로드 응답이 비정상입니다.`, type: 'error' }));
        return;
      }
      const blob = new Blob([result.data], { type: result.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      dispatch(showSnackbar({ message: `"${finalFileName}" 다운로드 완료`, type: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: error?.message || '다운로드 실패', type: 'error' }));
    }
  };

  // 엑셀 다운로드 (그리드 데이터 Export)
  const ExcelDownload1 = async () => {
    try {
      const api = gridRef1?.current?.api;
      if (!api) return;

      const fileName = `${dayjs().format('YYYYMMDDHHmm')}산업재해현황.xlsx`;
      api.exportDataAsExcel({
        fileName,
      });
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.message || '엑셀 다운로드 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  const PrintLogic1 = async () => {
    dispatch(showLoading());
    try {
      const toPrint = (rowData1 || []).filter((r) => r.deleteYn !== 'Y');
      if (!toPrint.length) {
        dispatch(showSnackbar({ message: '인쇄할 데이터가 없습니다.', type: 'warning' }));
        dispatch(closeLoading());
        return;
      }
      const custNm = searchInfo.custList?.find((c) => c.value === searchInfo.custCd)?.name || '';
      const headerData = { title: '산업재해현황', custNm, createDate: dayjs().format('YYYY-MM-DD'), userNm: userInfo?.userNm || '' };
      const tableData = toPrint.map((row) => ({
        ...row,
        accidentDate: row.accidentDate ? dayjs(row.accidentDate).format('YYYY-MM-DD HH:mm') : '',
        joinDate: row.joinDate ? dayjs(row.joinDate).format('YYYY-MM-DD') : '',
        returnDate: row.returnDate ? dayjs(row.returnDate).format('YYYY-MM-DD') : '',
      }));
      const printData = {
        FileName: 'ACS_BASIC_01',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank');
      });
    } catch (e) {
      dispatch(showSnackbar({ message: e?.message || '인쇄 중 오류가 발생했습니다.', type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  //#endregion

  return (
    <div className="wrap">
      <ACS_BASIC_01
        gridRef1={gridRef1}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        validateSelection={validateSelection}
        SearchLogic1={SearchLogic1}
        NewYnErrorMsg={NewYnErrorMsg}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        gongjongModalToggle={gongjongModalToggle}
        setGongjongModalToggle={setGongjongModalToggle}
        custCd={searchInfo?.custCd}
        rowClickData={rowClickData}
        fileModalToggle={fileModalToggle}
        setFileModalToggle={setFileModalToggle}
        currentFileFieldType={currentFileFieldType}
        PopupClickEvent1={PopupClickEvent1}
        PopupGongjongClickEvent={PopupGongjongClickEvent}
        HandleManageSelection={HandleManageSelection}
        HandleGongjongSelection={HandleGongjongSelection}
        PopupFileClickEvent={PopupFileClickEvent}
        SaveLogicPreview={SaveLogicPreview}
        DownloadLogic1={DownloadLogic1}
        ExcelDownload1={ExcelDownload1}
        handleRowSelection1={handleRowSelection1}
      />
    </div>
  );
}

export default ACS_BASIC_01F;
